import { getHireJobsConvertibleShiftsRetrieveQueryOptions } from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { jobId: string; enabled: boolean };

export const convertibleShiftsQuery = ({ jobId, enabled }: QueriesInput) =>
  getHireJobsConvertibleShiftsRetrieveQueryOptions(jobId, { query: { enabled } });

// Gated on a per-location flag only the component can read; warming would 404 while it's off.
export const queries = (): Array<WarmableQuery> => [];
